
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import apiUrl from "../../environment/Api";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import "../../assets/css/EnquiryReport.css";

function ExpenseReport() {
  const { id } = useParams();
  const [filtered, setFiltered] = useState([]);
  const [courses, setCourses] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});
  const [totalincome, settotalexpense] = useState([])
  const [branch, setbranch] = useState([])
  const [Branches, setselectBranch] = useState([])
  const [loading, setLoading] = useState(false)

  const [uniquefiltertype, setuniquefiltertype] = useState([]);
  const [uniquepaid_to, setuniquepaid_to] = useState([]);

  const [selected_paid_to, setselected_paid_to] = useState([]);

  const [totalamount, settotalamount] = useState(0);




  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const leadsResponse = await axios.get(apiUrl + "/expense_list");
        setFiltered(leadsResponse.data);

        const filteredData = leadsResponse.data.reduce((acc, item) => {
          if (!acc.some((obj) => obj.type[0].type === item.type[0].type)) {
            acc.push(item);
          }
          return acc;
        }, []);

        setuniquefiltertype(filteredData);

        // first code filter unique paid to and it's working code 
        // const unique_paid_to = leadsResponse.data.reduce((acc, item) => {
        //   if (!acc.some((obj) => obj.paidto === item.paidto)) {
        //     acc.push(item);
        //   }
        //   return acc;
        // }, []);

        // setuniquepaid_to(unique_paid_to);

        // second code to filter unique paid to
        const unique_paid_to = leadsResponse.data.reduce((acc, item) => {
          // Extract branch IDs as an array
          const branchIds = item.branch_id.map((branch) => branch.branch_id);

          // Check if the same paidto exists with a different branch_id
          const existsWithDifferentBranch = acc.some((obj) =>
            obj.paidto === item.paidto &&
            !obj.branch_id.some((branch) => branchIds.includes(branch.branch_id))
          );

          // If not already added or exists with a different branch_id, add it
          if (!acc.some((obj) => obj.paidto === item.paidto) || existsWithDifferentBranch) {
            acc.push(item);
          }

          return acc;
        }, []);

        setuniquepaid_to(unique_paid_to);

        // console.log("The unique_paid_to is : ", unique_paid_to);


        const totalExpense = await axios.get(apiUrl + "/expense");
        settotalexpense(totalExpense.data)


        const branchresponse = await axios.get(apiUrl + "/branch");

        console.log("Branch response:", branchresponse.data);


        if (Array.isArray(branchresponse.data)) {
          setbranch(branchresponse.data);
        } else {
          console.error("Unexpected data format:", branchresponse.data);
        }


        const uniqueStatuses = Array.from(
          new Set(leadsResponse.data.map((item) => item.followups_status))
        ).map((status) => ({ followups_status: status }));

        setStatuses(uniqueStatuses);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setTimeout(
        () => {
          setLoading(false)
        }, 500
      )
    };

    fetchData();
  }, [id]);

  const formatDatefitching = (date) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(date).toLocaleDateString(undefined, options);
  };

  // ================ code to convert the date =============================
  const formatDate = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);

    const day = date.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single-digit months
    const year = date.getFullYear();

    return `${day}-${month}-${year}`; // Format as "day-month-year"
  };
  // ================ code to convert the date =============================


  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;

  const filteredData = filtered.filter((item) => {
    // const isSearchMatch = searchTerm
    //   ? [
    //     item.branch_id?.[0]?.branch_name,
    //     item.mobile_no,
    //     item.notes,
    //     item.from,
    //     item.paidto,
    //     item.paytype,
    //   ].some(
    //     (field) =>
    //       field &&
    //       String(field).toLowerCase().includes(searchTerm.toLowerCase())
    //   )
    //   : true;




    // old search match code
    // const isSearchMatch = searchTerm
    // ? [
    //     Array.isArray(item.branch_id) ? item.branch_id[0]?.branch_name : item.branch_id?.branch_name, // Handles both array and object cases
    //     item.mobile_no,
    //     item.notes,
    //     item.from,
    //     item.paidto,
    //     item.paytype,
    //   ].some(
    //     (field) =>
    //       field &&
    //       String(field).toLowerCase().includes(searchTerm.toLowerCase())
    //   )
    // : true;

    // new search match code
    const isSearchMatch = searchTerm
      ? (item.branch_id[0]?.branch_name &&
        item.branch_id[0]?.branch_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item.type[0]?.type &&
        item.type[0]?.type.toUpperCase().includes(searchTerm.toUpperCase())) ||
      (item.mobile_no && String(item.mobile_no).includes(searchTerm)) ||
      (item.notes &&
        item.notes.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item.paidto &&
        item.paidto.toUpperCase().includes(searchTerm.toUpperCase())) ||
      (item.paytype &&
        item.paytype.toUpperCase().includes(searchTerm.toUpperCase())) ||
      (String(item.amount) &&
        String(item.amount).toUpperCase().includes(searchTerm.toUpperCase()))
      : true;





    const isStatusMatch = selectedStatus
      ? item.type?.[0]?._id === selectedStatus
      : true;

    const isBranchMatch = Branches
      ? item.branch_id[0]?.branch_name === Branches
      : true;

    const itemEnquiryDate = new Date(item.date);
    const isFromDateMatch = fromDate
      ? itemEnquiryDate >= new Date(fromDate)
      : true;

    const isToDateMatch = toDate ? itemEnquiryDate <= new Date(toDate) : true;

    // code to match the paid to
    const ispaid_to_match = selected_paid_to
      ? item.paidto === selected_paid_to
      : true;


    return (isSearchMatch &&
      isFromDateMatch &&
      isStatusMatch &&
      isToDateMatch &&
      isBranchMatch &&
      ispaid_to_match
    ) // Apply both filters
  });

  const currentEntries = filteredData.slice(
    indexOfFirstEntry,
    indexOfLastEntry
  );

  // ============= code to set the dynamic total amount ===================
  // useEffect(() => {
  //   if(currentEntries && currentEntries.length>0)
  //   {
  //     console.log("the currentEntries in attendance report page is : ",currentEntries);
  //     sumTotalAmount();
  //   }
  // }, [currentEntries]);
  useEffect(() => {
    if (currentEntries && currentEntries.length > 0) {
      console.log("The currentEntries in attendance report page are:", currentEntries);
      sumTotalAmount(); // Sum the total amount if there are matching entries
    } else {
      // If no entries match the search, set totalAmount to 0
      settotalamount(0);
    }
  }, [currentEntries]);

  const sumTotalAmount = () => {
    const totalAmount = currentEntries.reduce((sum, item) => sum + item.amount, 0);
    // console.log("The totalAmount in the sumTotalAmount is : ",totalAmount);
    settotalamount(totalAmount);
  }
  // ============= code to set the dynamic total amount ===================




  const handleEntriesPerPageChange = (event) => {
    setEntriesPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleCourseChange = (event) => {
    setSelectedCourse(event.target.value);
    setCurrentPage(1);
  };

  const handleBranchChange = (event) => {
    setselectBranch(event.target.value);
    setCurrentPage(1);

    console.log("The selected branch is value in the handleBranchChange is : ", event.target.value);
    console.log("The selected branch == '' is value in the handleBranchChange is : ", event.target.value == '');

    if (event.target.value == '') {
      const unique_paid_to = filtered.reduce((acc, item) => {
        // Extract branch IDs as an array
        const branchIds = item.branch_id.map((branch) => branch.branch_id);

        // Check if the same paidto exists with a different branch_id
        const existsWithDifferentBranch = acc.some((obj) =>
          obj.paidto === item.paidto &&
          !obj.branch_id.some((branch) => branchIds.includes(branch.branch_id))
        );

        // If not already added or exists with a different branch_id, add it
        if (!acc.some((obj) => obj.paidto === item.paidto) || existsWithDifferentBranch) {
          acc.push(item);
        }

        return acc;
      }, []);

      setuniquepaid_to(unique_paid_to);
    }
    else {
      let unique_paid_to = filtered.filter(
        (item) => item.branch_id[0]?.branch_name.trim().toLowerCase() === event.target.value.trim().toLowerCase()
      );

      unique_paid_to = unique_paid_to.reduce((acc, item) => {
        if (!acc.some((obj) => obj.paidto === item.paidto)) {
          acc.push(item);
        }
        return acc;
      }, []);

      setuniquepaid_to(unique_paid_to);
    }
  };

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
    setCurrentPage(1);
  };

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  // =========== code to fetch the data at initially ================
  useEffect(() => {
    handleClearFilters();
  }, []);
  // =========== code to fetch the data at initially ================

  const handleClearFilters = () => {
    setSelectedCourse("");
    setSelectedStatus("");
    setselectBranch("");
    setFromDate("");
    setToDate("");
    setSearchTerm("");
    setCurrentPage(1);
    setselected_paid_to("");
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  const handleCopy = () => {
    const tableElement = document.getElementById("tableId");
    if (tableElement) {
      const tableData = tableElement.innerText;
      navigator.clipboard
        .writeText(tableData)
        .then(() => {
          alert("Expense Table data copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    } else {
      console.error("Table with ID 'tableId' not found");
    }
  };

  // This is the first code 
  // const handleCSVExport = () => {
  //   const csvHeaders = [
  //     "S.No",
  //     "branch",
  //     "Type",
  //     "Date",
  //     "Notes",
  //     "Amount",
  //     "From",
  //     "To",
  //     "Paytype",
  //   ];
  //   const csvData = filteredData.map((item, index) => [
  //     index + 1,
  //     item.branch_id,
  //     item.type,
  //     formatDatefitching(item.date),
  //     item.notes,
  //     item.amount,
  //     item.from,
  //     item.to,

  //     item.paytype,
  //   ]);

  //   const csvContent = [
  //     csvHeaders.join(","), // Headers
  //     ...csvData.map((row) => row.join(",")), // Data rows
  //   ].join("\n");

  //   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  //   const link = document.createElement("a");
  //   link.href = URL.createObjectURL(blob);
  //   link.setAttribute("download", "expense_report.csv");
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  const handleCSVExport = () => {
    const csvHeaders = [
      "S.No",
      "Branch",
      "Type",
      "Date",
      "Notes",
      "Paid To",
      "Paytype",
      "Amount"
    ];
    const csvData = filteredData.map((item, index) => [
      index + 1,
      item.branch_id[0].branch_name,
      item.type[0].type,
      formatDate(item.date),
      item.notes,
      item.paidto,
      item.paytype,
      item.amount
    ]);

    const csvContent = [
      csvHeaders.join(","), // Headers
      ...csvData.map((row) => row.join(",")), // Data rows
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "expense_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExport = () => {
    const tableElement = document.getElementById("tableId");
    if (tableElement) {
      const worksheet = XLSX.utils.table_to_sheet(tableElement);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, "expense_table_data.xlsx");
    } else {
      console.error(
        "Table with ID 'tableId' not found. Check if the table is rendered in the DOM."
      );
    }
  };

  // const handleGeneratePDF = () => {
 

  //   const tableElement = document.getElementById("tableId");
  //   const tablerowElement = document.getElementById("total_amount");

  //   if (!tableElement || !tablerowElement) {
  //     console.error("Table with ID 'tableId' not found");
  //     return;
  //   }
  //   html2canvas(tableElement)
  //     .then((canvas1) => {

  //       const imgData1 = canvas1.toDataURL("image/png");
  //       const imgHeight1 = (canvas1.height * 190) / canvas1.width; // Scale image height


  //       // Capture the second table 
  //       html2canvas(tablerowElement).then((canvas2) => {
  //         const imgData2 = canvas2.toDataURL("image/png");
  //         const imgHeight2 = (canvas2.height * 190) / canvas2.width; // Scale image height

  //         // Create a new PDF document
  //         const pdf = new jsPDF();

  //         // Add first table image
  //         pdf.addImage(imgData1, "PNG", 10, 10, 190, imgHeight1);

  //         // Add second table image
  //         // pdf.addImage(imgData2, "PNG", 10, 10 + imgHeight1 + 10, 190, imgHeight2);
  //         pdf.addImage(imgData2, "PNG", 10, 10 + imgHeight1 + 10, 190, imgHeight2);

  //         // Save the PDF
  //         pdf.save("Expense_Report.pdf");
  //       });

  //     })
  //     .catch((error) => {
  //       console.error("Error generating PDF: ", error);
  //     });
  // };

  // const handleGeneratePDF = () => {
  //   const tableElement = document.getElementById("tableId");
  //   const totalAmountElement = document.getElementById("total_amount");
  
  //   if (!tableElement || !totalAmountElement) {
  //     console.error("Table with ID 'tableId' or 'total_amount' not found");
  //     return;
  //   }
  
  //   html2canvas(tableElement, { scale: 2, useCORS: true }).then((canvas1) => {
  //     html2canvas(totalAmountElement, { scale: 2, useCORS: true }).then((canvas2) => {
  //       const pdf = new jsPDF();
  //       const pageHeight = pdf.internal.pageSize.height;
  //       const imgWidth = 190;
  //       let positionY = 10;
  
  //       // Capture table image
  //       const imgHeight1 = (canvas1.height * imgWidth) / canvas1.width;
  //       pdf.addImage(canvas1.toDataURL("image/png"), "PNG", 10, positionY, imgWidth, imgHeight1);
  //       positionY += imgHeight1 + 10; // Add spacing after table
  
  //       // Capture total amount section
  //       const imgHeight2 = (canvas2.height * imgWidth) / canvas2.width;
  
  //       if (positionY + imgHeight2 > pageHeight) {
  //         pdf.addPage();
  //         positionY = 10;
  //       }
  
  //       pdf.addImage(canvas2.toDataURL("image/png"), "PNG", 10, positionY, imgWidth, imgHeight2);
  //       pdf.save("Expense_Report.pdf");
  //     });
  //   }).catch((error) => {
  //     console.error("Error generating PDF: ", error);
  //   });
  // };
  
  const handleGeneratePDF = () => {
    const tableElement = document.getElementById("tableId");
    const totalAmountElement = document.getElementById("total_amount");
  
    if (!tableElement || !totalAmountElement) {
      console.error("Table or Total Amount section not found");
      return;
    }
  
    html2canvas(tableElement, { scale: 2, useCORS: true }).then((canvas1) => {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.width;
      const pageHeight = pdf.internal.pageSize.height;
      const imgWidth = 190; // Set image width
      let positionY = 20; // Start position
  
      // 📌 **Title**
      pdf.setFontSize(20);
      pdf.text("Expense Report", pageWidth / 2, positionY, { align: "center" });
      positionY += 10; // Move below title
  
      // 📌 **Convert Table to Image**
      const imgData1 = canvas1.toDataURL("image/jpeg", 0.95);
      let imgHeight1 = (canvas1.height * imgWidth) / canvas1.width;
  
      // ✅ **Handle Large Tables with Multi-Page Support**
      if (imgHeight1 > pageHeight - 30) {
        let remainingHeight = imgHeight1;
        let sourceY = 0;
        let pageNumber = 1;
  
        while (remainingHeight > 0) {
          const cropHeight = Math.min(pageHeight - 40, remainingHeight);
          const pageCanvas = document.createElement("canvas");
          pageCanvas.width = canvas1.width;
          pageCanvas.height = Math.floor(cropHeight * (canvas1.width / imgWidth));
          const pageCtx = pageCanvas.getContext("2d");
  
          pageCtx.drawImage(
            canvas1,
            0, sourceY, canvas1.width, pageCanvas.height, // Source
            0, 0, pageCanvas.width, pageCanvas.height // Destination
          );
  
          const croppedImg = pageCanvas.toDataURL("image/jpeg", 0.95);
          pdf.addImage(croppedImg, "JPEG", 10, positionY, imgWidth, cropHeight);
  
          remainingHeight -= cropHeight;
          sourceY += pageCanvas.height;
  
          if (remainingHeight > 0) {
            pdf.addPage();
            positionY = 10;
            pageNumber++;
  
            // ✅ **Add Page Number**
            pdf.setFontSize(12);
            pdf.text(`Page ${pageNumber}`, pageWidth - 20, pageHeight - 10);
          }
        }
      } else {
        pdf.addImage(imgData1, "JPEG", 10, positionY, imgWidth, imgHeight1);
        positionY += imgHeight1 + 10; // Move below table
      }
  
      // 📌 **Capture and Add "Total Amount" Section**
      html2canvas(totalAmountElement, { scale: 2 }).then((canvas2) => {
        const imgData2 = canvas2.toDataURL("image/jpeg", 0.95);
        let imgHeight2 = (canvas2.height * imgWidth) / canvas2.width;
  
        if (positionY + imgHeight2 > pageHeight - 20) {
          pdf.addPage();
          positionY = 10;
        }
  
        pdf.addImage(imgData2, "JPEG", 10, positionY, imgWidth, imgHeight2);
  
        // 📌 **Calculate File Size in KB**
        const byteCharacters1 = atob(imgData1.split(",")[1]);
        const byteCharacters2 = atob(imgData2.split(",")[1]);
        const fileSizeKB = Math.round((byteCharacters1.length + byteCharacters2.length) / 1024);
  
        console.log(`Estimated PDF file size: ${fileSizeKB} KB`);
  
        // 📌 **Save PDF**
        pdf.save("Expense_Report.pdf");
      });
    }).catch((error) => {
      console.error("Error generating PDF: ", error);
    });
  };
  


  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    const tableElement = document.getElementById("tableId");
    if (tableElement) {
      printWindow.document.write(`
          <html>
            <head>
              <title>Print Expense Table</title>
              <style>
                table { width: 100%; border-collapse: collapse; }
                th, td { border: 1px solid #000; padding: 8px; text-align: left; }
                th { background-color: #f2f2f2; }

                /* Ensuring row structure remains intact */
                            .row { display: flex; flex-wrap: wrap; margin-top: 10px; }
                            .col-lg-9 { flex: 0 0 75%; max-width: 75%; }
                            .col-lg-3 { flex: 0 0 25%; max-width: 25%; }
                            .col-lg-6 { flex: 0 0 50%; max-width: 50%; text-align: center; font-weight: bold; }
                            
                            /* Page break handling for print */
                            @media print {
                                .row { page-break-inside: avoid; }
                                table { page-break-inside: auto; }
                            }
              </style>
            </head>
            <body>
              <h1>Expense Report</h1>
              <div>${tableElement.outerHTML}</div>

              <div class="row">
                <div class="col-lg-9"></div>
                <div class="col-lg-3">
                  <div class="row">
                    <div class="col-lg-6">Total Amount </div>
                    <div class="col-lg-6">${totalamount}.00</div>
                  </div>
                </div>
              </div>

            </body>
          </html>
        `);
      printWindow.document.close();
      printWindow.print();
    } else {
      console.error("Table with ID 'tableId' not found");
    }
  };



  useEffect(() => {
    gettoken();
    getprevillages();
  }, []);


  const gettoken = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);

      setroleid(response.data.detail.rolename);

      localStorage.setItem("role_id", response.data.detail.rolename);

      const id = response.data.detail.rolename;

      if (id) { }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const getprevillages = () => {
    const username = JSON.parse(localStorage.getItem("user_previllages"));
    console.log("tyhe username get by local stroage : ", username.modules);
    const total_previlages = username.modules;
    const new_enquiry = total_previlages.find((item) => item.name == "Expense Report")
    console.log("the new_enquiry is : ", new_enquiry.actions);

    setprevillages(new_enquiry.actions)
  }



  const paginate = (pageNumber) => setCurrentPage(pageNumber);


  const createPagination = () => {
    let liTag = [];
    let beforePage = currentPage - 1;
    let afterPage = currentPage + 1;
    let active;

    if (currentPage > 1) {
      liTag.push(
        <li className="page-item" key="prev">
          <button
            className="page-link"
            onClick={() => paginate(currentPage - 1)}
          >
            <FaAngleLeft /> Prev
          </button>
        </li>
      );
    }

    if (currentPage > 2) {
      liTag.push(
        <li className="page-item" key="first" onClick={() => paginate(1)}>
          <button className="page-link">1</button>
        </li>
      );
      if (currentPage > 3) {
        liTag.push(
          <li className="page-item disabled" key="dots1">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    if (currentPage === totalPages) {
      beforePage -= 2;
    } else if (currentPage === totalPages - 1) {
      beforePage -= 1;
    }

    if (currentPage === 1) {
      afterPage += 2;
    } else if (currentPage === 2) {
      afterPage += 1;
    }

    for (let plength = beforePage; plength <= afterPage; plength++) {
      if (plength > totalPages || plength <= 0) continue;
      active = currentPage === plength ? "active" : "";
      liTag.push(
        <li
          className={`page-item ${active}`}
          key={plength}
          onClick={() => paginate(plength)}
        >
          <button className="page-link">{plength}</button>
        </li>
      );
    }

    if (currentPage < totalPages - 1) {
      if (currentPage < totalPages - 2) {
        liTag.push(
          <li className="page-item disabled" key="dots2">
            <span className="page-link">...</span>
          </li>
        );
      }
      liTag.push(
        <li
          className="page-item"
          key="last"
          onClick={() => paginate(totalPages)}
        >
          <button className="page-link">{totalPages}</button>
        </li>
      );
    }

    if (currentPage < totalPages) {
      liTag.push(
        <li className="page-item" key="next">
          <button
            className="page-link"
            onClick={() => paginate(currentPage + 1)}
          >
            Next <FaAngleRight />
          </button>
        </li>
      );
    }

    return liTag;
  };











  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}
      <div className="container-fluid mb-3">
        <div
          className="card p-2"
          style={{
            marginTop: "-80px",
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          }}
        >
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-6 pt-2">
              <h6 style={{color:"#8f0505"}}>
                <b>Expense Report</b>
              </h6>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 pt-2">
            <div className="row" id="total_amount">
            <div className="col-lg-3"></div>
            <div className="col-lg-4" style={{ textAlign: 'end', textDecoration: "underline" }}><b>Total Amount</b></div>
         
            <div className="col-lg-4" style={{ textAlign: 'end', textDecoration: "underline" }}><b>{totalamount}.00</b></div>
          </div>
            </div>



          </div>
          <hr />
          <div className="row p-2">
            <div className="col-lg-2 col-md-3 col-sm-12 mx-3">
              <input
                type="date"
                value={fromDate}
                onChange={handleFromDateChange}
                className="form-control"
              />
            </div>
            <div className="col-lg-2 col-md-3 col-sm-12">
              <input
                type="date"
                value={toDate}
                onChange={handleToDateChange}
                className="form-control"
              />
            </div>

            <div className="col-lg-2 col-md-3 col-sm-12">
              <select
                value={Branches} // Ensure this matches the state variable for the selected branch
                // onChange={(e) => setselectBranch(e.target.value)} // Update the state
                onChange={handleBranchChange}
                className="form-control"
              >
                <option value="">All branches</option>
                {branch.map((branchItem) => (
                  <option key={branchItem._id} value={branchItem.branch_id[0]?.branch_name}>
                    {branchItem.branch_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-lg-2 col-md-3 col-sm-12">
              <select
                value={selectedStatus}
                onChange={handleStatusChange}
                className="form-control"
              >
                <option value="">Select Type</option>
                {/* {filteredData.map((item, index) =>
                item.type.length > 0 ? (
                  <option key={index} value={item.type[0]._id}>
                    {item.type[0].type}
                  </option>
                ) : null
              )} */}
                {uniquefiltertype.map((item, index) =>
                  item.type.length > 0 ? (
                    <option key={index} value={item.type[0]._id}>
                      {item.type[0].type}
                    </option>
                  ) : null
                )}
              </select>
            </div>

            <div className="col-lg-2 col-md-3 col-sm-12">
              <select className="form-control" onChange={(e) => setselected_paid_to(e.target.value)}>
                <option value=""> Paid To</option>
                {/* {currentEntries.map((expense) => ( */}
                {uniquepaid_to.map((expense) => (
                  <option key={expense._id} value={expense.paidto}>
                    {expense.paidto}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-lg-1 col-md-2 col-sm-12">
              <button className="btn btn-danger" onClick={handleClearFilters}>
                Clear
              </button>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-3 d-flex align-items-center">
              <p className="mb-0 mr-2">Show per page </p>
              <select
                value={entriesPerPage}
                onChange={handleEntriesPerPageChange}
                className="form-control mx-2"
                style={{ width: "50px" }}
              >
                {/* <option value={5}>5</option> */}
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={filteredData.length}>All</option>
              </select>
            </div>

            <div className="col-md-6">
              {previllages.download && (
                <button className="btn btn-secondary2 mx-2" onClick={handleCopy}>
                  Copy
                </button>
              )}
              {previllages.download && (
                <button className="btn btn-success2 mx-2" onClick={handleCSVExport}>
                  CSV
                </button>
              )}
              {previllages.download && (
                <button className="btn btn-excel2 mx-2" onClick={handleExport}>
                  Excel
                </button>
              )}
              {previllages.download && (
                <button className="btn btn-info2 mx-2" onClick={handleGeneratePDF}>
                  PDF
                </button>
              )}
              {previllages.download && (
                <button className="btn btn-warning2 mx-2" onClick={handlePrint}>
                  Print
                </button>
              )}

            </div>

            <div className="col-md-3 d-flex align-items-center">
              <input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={handleSearchChange}
                className="form-control"
              />
            </div>
          </div>
          <table id="tableId" className="table table-striped table-bordered mt-2">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Branch</th>
                <th>Type</th>
                <th>Date</th>
                <th>Notes</th>
                <th>Paid To</th>
                <th>Paytype</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {currentEntries.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1 + (currentPage - 1) * entriesPerPage}</td>
                  <td>{item.branch_id[0].branch_name}</td>
                  <td>{item.type[0]?.type}</td>
                  {/* <td>{new Date(item.date).toLocaleDateString()}</td> */}
                  <td>{formatDate(item.date)}</td>
                  <td>{item.notes}</td>
                  <td>{item.paidto}</td>
                  <td>{item.paytype}</td>
                  <td>{item.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="row" id="total_amount">
            <div className="col-lg-8"></div>
            <div className="col-lg-2" style={{ textAlign: 'end', textDecoration: "underline" }}><b>Total Amount</b></div>
            {/* <div className="col-lg-2" style={{ textAlign: 'end', textDecoration: "underline" }}><b>{totalincome.totalAmount}.00</b></div> */}
            <div className="col-lg-2" style={{ textAlign: 'end', textDecoration: "underline" }}><b>{totalamount}.00</b></div>
          </div>
          <br></br>
          <div className="row">
            <div className="mt-3 pb-5">
              <div className="row">
                <div className="col-lg-7 col-sm-12 mt-1">
                  <span className="text-dark">
                    Page {currentPage} of {totalPages}
                  </span>
                </div>
                <div className="col-lg-5">
                  <nav>
                    <ul className="pagination justify-content-center">
                      {createPagination()}
                    </ul>
                  </nav>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default ExpenseReport;
